import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { OrganizationInput } from '../../../../models/general';
import { addOrganization } from "../../../../api/General/organization";
import Button from "../../../../components/ui/Button";
import Input from "../../../../components/ui/Input";

export default function AddOrganization() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [input, setInput] = useState<OrganizationInput>({ name: "" });
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = async () => {
    setError(null);
    try {
      await addOrganization(input);
      setInput({ name: "" });
      navigate("/settings/organizations");
    } catch {
      setError(t("Something went wrong!"));
    }
  };

  return (
    <div className="flex flex-col gap-4 p-4 items-center">
      <h1 className="text-2xl font-bold text-foreground">{t("Add Organization")}</h1>
      <div className="flex flex-col gap-4 w-full max-w-lg">
        {error && (
          <div role="alert" className="rounded-lg border border-destructive/50 bg-destructive/10 p-4 text-sm text-destructive">
            {error}
          </div>
        )}
        <Input
          label={t("Organization Name")}
          required
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => setInput({ ...input, name: event.target.value })}
          value={input.name}
        />
        <Button
          fullWidth
          onClick={handleSubmit}
        >
          {t("Submit")}
        </Button>
      </div>
    </div>
  );
}
